<template>
  <TradePassportCardSlot
    class="trade-passport-certificate"
    title="Education & Certifications"
    buttonLabel="+Add Education & Certifications"
    :hideFooter="props.userCertificates && props.userCertificates.length <= 3"
    emptyStateImage="certificates-empty"
    :emptyStateLabel="
      isUserProprtyOwner
        ? 'Certificates will appear here'
        : 'Your Certificates will appear here'
    "
    :isEmpty="!props.userCertificates.length"
    :numberOfRemainingItem="props.userCertificates.length"
    :isCustomActionHeader="
      props.userCertificates && props.userCertificates.length
    "
    @on-handle-footer-click="onRouteToCertificateOverview"
    @on-handle-click="onRouteToCertificateOverview"
  >
    <template #custom-action-header>
      <div class="tw-flex tw-gap-3 tw-items-center">
        <Button
          v-if="!isUserProprtyOwner"
          label="+Add"
          variant="secondary"
          class="!tw-w-auto md:!tw-min-h-[unset] md:!tw-px-2"
          @click="onRouteToCertificateOverview"
        />
        <BlueCircularPencilIcon
          v-if="!isUserProprtyOwner"
          @click="onRouteToCertificateOverview"
        />
      </div>
    </template>
    <template #content>
      <div class="tw-w-full">
        <div
          v-for="(certificate, index) in props.userCertificates.slice(0, 3)"
          :key="index"
          class="tw-w-full tw-flex tw-flex-col tw-gap-4 tw-py-4 tw-box-border"
          :class="{
            'tw-border-b-dashed-custom':
              index !== props.userCertificates.slice(0, 3).length - 1,
            '!tw-pt-0': index === 0,
          }"
        >
          <div class="tw-flex tw-items-start tw-gap-3 tw-w-full">
            <div
              class="tw-min-w-[68px] tw-w-[68px] tw-h-[68px] tw-rounded-[4.85px] tw-bg-[rgba(12,15,74,0.04)] tw-border-solid tw-border-[#DFDFDF] tw-border-[1px] tw-overflow-hidden"
            >
              <img
                src="@/assets/images/tradepassport-empty-thumbnail.png"
                class="tw-w-full tw-h-full tw-object-cover"
              />
            </div>
            <div
              class="tw-w-full tw-flex tw-flex-col tw-gap-[.1rem] tw-items-start"
            >
              <div class="tw-flex tw-items-start tw-gap-2">
                <Text
                  variant="h6"
                  lineHeight="20px"
                  textAlign="left"
                  class="tw-w-[70%] md:!tw-text-[.9rem]"
                  >{{ certificate?.certificate?.name }}</Text
                >
                <PendingChip
                  class="tw-w-[auto]"
                  label="Pending Verification"
                  v-if="
                    certificate?.userVerificationStatus ===
                    UserVerificationStatusEnum.PENDING_VERIFICATION
                  "
                />

                <AcceptChip
                  class="tw-w-[auto]"
                  label="Accepted"
                  v-if="
                    certificate?.userVerificationStatus ===
                      UserVerificationStatusEnum.VERIFIED && !isUserProprtyOwner
                  "
                />
                <AcceptChip
                  class="tw-w-[auto]"
                  label="Verified"
                  v-if="
                    certificate?.userVerificationStatus ===
                      UserVerificationStatusEnum.VERIFIED && isUserProprtyOwner
                  "
                />
                <RejectChip
                  class="tw-w-[auto]"
                  label="Rejected"
                  v-if="
                    certificate?.userVerificationStatus ===
                    UserVerificationStatusEnum.REJECTED
                  "
                />
              </div>
              <Text
                variant="p"
                textColor="rgba(12, 15, 74, 0.8)"
                lineHeight="18px"
                class="md:!tw-text-[.7rem]"
                v-if="certificate?.metadata?.registrationNumber"
              >
                Membership No:
                {{ certificate?.metadata?.registrationNumber }}</Text
              >
            </div>
          </div>
        </div>
      </div>
    </template>
  </TradePassportCardSlot>
</template>
<script setup>
import { computed } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";

import TradePassportCardSlot from "../slots/TradePassportCardSlot.vue";
import Text from "@/core/components/ui/general/Text.vue";
import Button from "@/core/components/ui/general/Button.vue";
import BlueCircularPencilIcon from "@/core/components/icons/BlueCircularPencilIcon.vue";
import { UserVerificationStatusEnum } from "@/core/enums/RolesEnum";
import {
  getImageStringToImageURL,
  isExpiredDate,
  setDirectStoragePathToImage,
} from "@/core/utils/common";
import PendingChip from "@/modules/dashboard/components/Chips/PendingChip.vue";
import AcceptChip from "@/modules/dashboard/components/Chips/AcceptChip.vue";
import RejectChip from "@/modules/dashboard/components/Chips/RejectChip.vue";
import appFilters from "@/filters";
import { USER_STORE } from "@/store/modules/user";
import { UserRolesEnum } from "@/core/enums/RolesEnum";
import { TRADE_ESTIMATE_STORE } from "@/store/modules/trade-estimate";
import { TRADE_PASSPOSRT_DETAILS_ROUTE } from "../../routes";

const store = useStore();
const router = useRouter();

const props = defineProps(["userCertificates"]);

const user = computed(() => store.getters[`${USER_STORE}/user`]);

const getIsOpenTradePassportasViewMode = computed(
  () => store.getters[`${TRADE_ESTIMATE_STORE}/isOpenTradePassportasViewMode`]
);

const isUserProprtyOwner = computed(
  () =>
    user.value?.role?.name === UserRolesEnum.PROPERTY_OWNER ||
    getIsOpenTradePassportasViewMode.value
);

const onRouteToCertificateOverview = () => {
  router.push({
    name: TRADE_PASSPOSRT_DETAILS_ROUTE,
    params: { type: "certificate" },
  });
};
</script>
<style lang="scss" scoped></style>
